import * as React from "react";
import { Trans } from "gatsby-plugin-react-i18next";

const Landing = () => {
  return (
    <>
      <section id="home" className="w-full relative z-20 overflow-hidden">
        <div className="absolute right-0 top-0 w-200 h-200 lg:w-320 lg:h-320">
          <img
            className="w-full h-full object-contain"
            width="320"
            height="320"
            src="/images/icons/top-rarr.svg"
            alt="right-arrow"
          />
        </div>

        <div className="pt-100 md:pt-120 lg:pt-144 container">
          <div className="flex items-start flex-col lg:flex-row relative overflow-visible">
            <div className="text-navy-blue lg:shrink-0 lg:w-640">
              <h1 className="font-heading font-bold text-28 md:text-48">
                <Trans>
                  We build high-quality crypto products that unify the user experience within
                  blockchain ecosystems.
                </Trans>
              </h1>
              <p className="mt-20 mb-30 md:my-40 font-normal leading-relaxed">
                <Trans>
                  By focusing on interoperability and composability on the backend, our products
                  provide a seamless experience for users allowing them to take their first step
                  into the ever-growing world of Blockchain.
                </Trans>
              </p>
              <a href="/#products" className="btn-big md:w-200">
                <Trans>Learn more</Trans>
              </a>
              <p className="mt-32 md:mt-40 text-grey-text">
                <Trans>Keep up with our updates on</Trans>
              </p>
              <ul className="flex mt-30 -mx-7">
                <li className="px-7">
                  <a
                    href="https://twitter.com/dcspark_io"
                    rel="noopener noreferrer"
                    target="_blank"
                    title="Twitter"
                    className="group flex items-center justify-center w-40 h-40 rounded-full text-navy-blue bg-grey-social transition hover:bg-navy-blue"
                  >
                    <svg
                      className="w-20 h-20 fill-current group-hover:text-white transition"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.999756 12.6387C2.34868 13.4982 3.95096 14 5.67225 14C11.3315 14 14.5288 9.2492 14.336 4.98821C14.9315 4.56153 15.4484 4.02818 15.8569 3.42009C15.31 3.661 14.7226 3.82391 14.1064 3.89684C14.7354 3.52277 15.2188 2.92883 15.4462 2.22096C14.8573 2.56818 14.205 2.82034 13.511 2.9564C12.955 2.36754 12.1628 2 11.2859 2C9.31854 2 7.87251 3.82464 8.3168 5.71966C5.7836 5.5934 3.53734 4.38737 2.03436 2.55403C1.23559 3.91607 1.62001 5.69753 2.97769 6.59914C2.47791 6.58354 2.00734 6.44676 1.59664 6.21999C1.56378 7.62375 2.57539 8.93608 4.0415 9.22888C3.61218 9.34498 3.14234 9.37111 2.66519 9.2804C3.05253 10.4846 4.1784 11.3597 5.51235 11.3844C4.23133 12.3829 2.617 12.8284 0.999756 12.6387Z"
                      />
                    </svg>
                    <span className="hidden">Twitter</span>
                  </a>
                </li>
                <li className="px-7">
                  <a
                    href="https://discord.gg/6zY6sybPEk"
                    rel="noopener noreferrer"
                    target="_blank"
                    title="Discord"
                    className="group flex items-center justify-center w-40 h-40 rounded-full text-navy-blue bg-grey-social transition hover:bg-navy-blue"
                  >
                    <svg
                      className="w-20 h-20 fill-current group-hover:text-white transition"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M13.3179 2.99346C12.2985 2.52418 11.222 2.19043 10.1159 2.00074C10.1059 1.99865 10.0955 1.99991 10.0863 2.00431C10.0771 2.00871 10.0696 2.01603 10.0649 2.02512C9.91823 2.29074 9.78511 2.56365 9.66608 2.84278C8.47418 2.66109 7.26162 2.66109 6.06971 2.84278C5.95019 2.56274 5.81481 2.28974 5.6642 2.02512C5.65956 2.01603 5.65205 2.00871 5.64284 2.00431C5.63363 1.99991 5.62323 1.99865 5.61324 2.00074C4.50729 2.191 3.4309 2.52472 2.41129 2.99346C2.40657 2.99473 2.40217 2.99696 2.39836 3.00001C2.39455 3.00306 2.3914 3.00686 2.38913 3.01118C0.350521 6.05802 -0.20788 9.02951 0.0646729 11.9656C0.0670446 11.9805 0.0749594 11.9939 0.0868317 12.0032C1.27349 12.8852 2.60117 13.5596 4.01337 13.9975C4.02331 14.0006 4.03395 14.0005 4.04385 13.9973C4.05375 13.9942 4.06245 13.988 4.06877 13.9798C4.37402 13.5644 4.64383 13.1241 4.87535 12.6636C4.87862 12.6574 4.88052 12.6506 4.88093 12.6436C4.88134 12.6366 4.88025 12.6297 4.87773 12.6231C4.87521 12.6166 4.87132 12.6107 4.86632 12.6059C4.86132 12.601 4.85533 12.5972 4.84876 12.5949C4.42526 12.4314 4.01486 12.2358 3.62116 12.0099C3.61431 12.0052 3.6087 11.9989 3.60482 11.9916C3.60094 11.9842 3.59892 11.9761 3.59892 11.9678C3.59892 11.9595 3.60094 11.9513 3.60482 11.944C3.6087 11.9366 3.61431 11.9303 3.62116 11.9257L3.86491 11.7351C3.87237 11.7299 3.88127 11.727 3.89039 11.727C3.89951 11.727 3.90841 11.7299 3.91587 11.7351C5.15291 12.3155 6.50257 12.6164 7.869 12.6164C9.23543 12.6164 10.5851 12.3155 11.8221 11.7351C11.8297 11.7301 11.8386 11.7275 11.8476 11.7275C11.8567 11.7275 11.8655 11.7301 11.8731 11.7351C11.9529 11.8016 12.0349 11.8658 12.1168 11.9279C12.1237 11.9326 12.1293 11.9388 12.1332 11.9462C12.1371 11.9535 12.1391 11.9617 12.1391 11.97C12.1391 11.9783 12.1371 11.9865 12.1332 11.9938C12.1293 12.0011 12.1237 12.0074 12.1168 12.0121C11.7247 12.2404 11.3141 12.4354 10.8892 12.5949C10.8828 12.5977 10.877 12.6019 10.8722 12.607C10.8674 12.6121 10.8636 12.6182 10.8611 12.6248C10.8586 12.6314 10.8575 12.6384 10.8578 12.6454C10.858 12.6525 10.8597 12.6594 10.8627 12.6658C11.0993 13.1201 11.3681 13.557 11.667 13.9731C11.6733 13.9814 11.682 13.9875 11.6919 13.9907C11.7018 13.9939 11.7125 13.9939 11.7224 13.9909C13.1374 13.5546 14.4675 12.8802 15.6556 11.9966C15.6618 11.9925 15.6669 11.9869 15.6704 11.9803C15.6739 11.9737 15.6757 11.9664 15.6756 11.9589C16.0001 8.79377 15.1708 5.61789 13.34 3.01561C13.3383 3.01047 13.3354 3.0058 13.3315 3.00195C13.3277 2.99811 13.323 2.9952 13.3179 2.99346ZM5.2587 10.1796C4.48314 10.1796 3.84496 9.46604 3.84496 8.59298C3.84496 7.71993 4.46984 7.0042 5.2587 7.0042C6.04755 7.0042 6.68351 7.72214 6.67243 8.59077C6.66135 9.45939 6.04533 10.1796 5.2587 10.1796ZM10.486 10.1796C9.7104 10.1796 9.07223 9.46604 9.07223 8.59298C9.07223 7.71993 9.6971 7.0042 10.486 7.0042C11.2748 7.0042 11.9108 7.72214 11.8997 8.59077C11.8886 9.45939 11.2792 10.1796 10.486 10.1796Z" />
                    </svg>
                    <span className="hidden">Discord</span>
                  </a>
                </li>
                <li className="px-7">
                  <a
                    href="https://github.com/dcSpark"
                    rel="noopener noreferrer"
                    target="_blank"
                    title="Github"
                    className="group flex items-center justify-center w-40 h-40 rounded-full text-navy-blue bg-grey-social transition hover:bg-navy-blue"
                  >
                    <svg
                      className="w-20 h-20 fill-current group-hover:text-white transition"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 0C3.58 0 0 3.57878 0 7.99728C0 11.5361 2.29 14.5251 5.47 15.5847C5.87 15.6547 6.02 15.4147 6.02 15.2048C6.02 15.0149 6.01 14.3851 6.01 13.7153C4 14.0852 3.48 13.2255 3.32 12.7756C3.23 12.5457 2.84 11.836 2.5 11.646C2.22 11.4961 1.82 11.1262 2.49 11.1162C3.12 11.1062 3.57 11.696 3.72 11.9359C4.44 13.1455 5.59 12.8056 6.05 12.5957C6.12 12.0759 6.33 11.726 6.56 11.5261C4.78 11.3261 2.91937 10.6358 2.91937 7.57742C2.91937 6.70771 3.22938 5.98796 3.73938 5.42815C3.65938 5.22822 3.38 4.4085 3.81938 3.30887C3.81938 3.30887 4.48937 3.09894 6.01937 4.12859C7.32841 3.76871 8.71034 3.76871 10.0194 4.12859C11.5494 3.08895 12.2194 3.30887 12.2194 3.30887C12.6594 4.4085 12.3794 5.22822 12.2994 5.42815C12.8094 5.98796 13.1194 6.69772 13.1194 7.57742C13.1194 10.6464 11.2494 11.3261 9.46937 11.5261C9.75937 11.776 10.0094 12.2558 10.0094 13.0056C10.0094 14.0752 9.99938 14.9349 9.99938 15.2048C9.99938 15.4147 10.1494 15.6647 10.5494 15.5847C13.71 14.5251 16 11.5261 16 7.99728C16 3.57878 12.42 0 8 0Z"
                      />
                    </svg>
                    <span className="hidden">Github</span>
                  </a>
                </li>
                <li className="px-7">
                  <a
                    href="https://medium.com/dcspark"
                    rel="noopener noreferrer"
                    target="_blank"
                    title="Medium"
                    className="group flex items-center justify-center w-40 h-40 rounded-full text-navy-blue bg-grey-social transition hover:bg-navy-blue"
                  >
                    <svg
                      className="w-20 h-20 fill-current group-hover:text-white transition"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.37167 5.23917C2.39667 4.99333 2.3025 4.75083 2.11917 4.58583L0.2525 2.33583V2H6.05083L10.5325 11.8292L14.4725 2H20V2.33583L18.4033 3.86667C18.2658 3.97167 18.1975 4.14417 18.2258 4.315V15.5633C18.1975 15.7333 18.2658 15.9058 18.4033 16.0108L19.9625 17.5417V17.8775H12.1192V17.5417L13.735 15.9733C13.8933 15.815 13.8933 15.7683 13.8933 15.5258V6.43417L9.4025 17.8408H8.79583L3.56667 6.43417V14.0792C3.52333 14.4 3.63 14.7242 3.85583 14.9558L5.95667 17.5042V17.8408H0V17.5042L2.10083 14.9558C2.32583 14.7233 2.42583 14.3975 2.37167 14.0792V5.23917Z"
                      />
                    </svg>
                    <span className="hidden">Telegram</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="ml-auto lg:ml-20 hidden md:block max-md:-mt-200 max-md:-mb-80 lg:-my-0 items-center shrink-0 illustration">
              <div className="w-full h-full opacity-0 -translate-x-1/2 animate-from-bottom">
                <img
                  className="w-full object-contain"
                  width="548"
                  height="554"
                  src="/images/Illustration.svg"
                  alt="illustration"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Landing;
